<div>
	@if (showForm()) {
		<nz-tabs [nzSelectedIndex]="selectedTabIndex()">
			<nz-tab [nzTitle]="edit() ? 'Edit User' : 'Add User'">
				<app-setup-wizard-user-form
					[loading]="loading()"
					[edit]="edit()?.after || edit()?.before || null"
					(onClear)="onFormClear()"
					(onSubmit)="onFormSubmit($event)"
				></app-setup-wizard-user-form>
			</nz-tab>
			@if (edit()) {
				<nz-tab nzTitle="Section Enrollment">
					<app-setup-wizard-sections-table
						[enableEditButton]="false"
						[enableToggleDisableButton]="false"
						[enableRemoveButton]="false"
						[enableResetButton]="false"
						[enableEnrollButton]="true"
						[enableUnenrollButton]="true"
						[pageSize]="2"
						[columnsFilter]="sectionTableColumns()"
						[selectedUser]="edit()"
						(onEnroll)="onEnroll($event)"
						(onUnenroll)="onUnenroll($event)"
					></app-setup-wizard-sections-table>
				</nz-tab>

				<nz-tab nzTitle="Location Assignment">
					<app-setup-wizard-locations-table
						[enableEditButton]="false"
						[enableToggleDisableButton]="false"
						[enableRemoveButton]="false"
						[enableResetButton]="false"
						[enableAssignButton]="true"
						[enableUnassignButton]="true"
						[pageSize]="2"
						[columnsFilter]="locationTableColumns()"
						[selectedUser]="edit()"
						(onAssign)="onAssign($event)"
						(onUnassign)="onUnassign($event)"
					></app-setup-wizard-locations-table>
				</nz-tab>
			}
		</nz-tabs>
	} @else {
		<div class="top-buttons">
			<button nz-button nzType="primary" (click)="onAdd()" class="add-button">Add</button>

			<div>
				<app-setup-wizard-upload-csv-button></app-setup-wizard-upload-csv-button>

				<app-setup-wizard-download-csv-button
					[key]="SetupWizardPayloadObjectKeys.users"
				></app-setup-wizard-download-csv-button>
			</div>
		</div>
	}
</div>
<div>
	<app-setup-wizard-users-table
		[selectedRow]="edit()"
		(onEdit)="onEdit($event)"
		(onEditSections)="onEditSections($event)"
		(onEditLocations)="onEditLocations($event)"
		(onToggleDisable)="onToggleDisable($event)"
		(onRemove)="onRemove($event)"
		(onReset)="onReset($event)"
	></app-setup-wizard-users-table>
</div>
